import {
  MediaUploadData,
  MediaUploadElement,
} from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext, useState } from "react";
import { Flex } from "../../flex";
import { ImageUpload } from "../../image-upload";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import { BrandKitContext } from "../review-form-editor-contexts";
import * as reviewMediaUploadCss from "./review-media-upload.module.css";

export const ReviewMediaUpload = memo(function ReviewMediaUpload({
  element,
  setData,
  data,
  showRequired,
}: {
  element: MediaUploadElement;
  setData: (data: MediaUploadData) => void;
  data?: MediaUploadData;
  showRequired: boolean;
}) {
  const brandKit = useContext(BrandKitContext);

  const fontFamily = brandKit.font.fontFamily;

  const [value, setValue] = useState<string | undefined>();

  function handleValueChange(value: URL | undefined) {
    setValue(value?.toString());
    if (value) {
      setData?.({ type: element.type, url: value.toString() });
    }
  }

  const rawUrl = data?.url || value;
  const url = rawUrl ? new URL(rawUrl) : undefined;

  const showRequiredState = showRequired && element.required;

  return (
    <Flex justify="center">
      <Flex
        dir="column"
        justify="center"
        style={{ width: `${element.widthPercentage}%`, fontFamily }}
      >
        <ImageUpload
          className={reviewMediaUploadCss.imageUpload}
          onChange={handleValueChange}
          value={url}
        />
        {showRequiredState && (
          <Text fontSize="sm" textColor="error">
            This question is required
          </Text>
        )}
      </Flex>
    </Flex>
  );
});

export const mediaUploadInspector: InspectorConfig<MediaUploadElement> = {
  sections: [
    {
      fields: [
        { widget: "toggle", path: "required", label: "Required" },
        {
          widget: "number",
          min: 0,
          max: 100,
          path: "widthPercentage",
          label: "Width Percentage",
        },
      ],
    },
  ],
};
